import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
//上拉刷新
// native: 适用于 PC 端，支持基本的自定义滚动条。 slide: 适用于移动端
// import vuescroll from 'vuescroll-slide';
// Vue.use(vuescroll, {
// 	ops: {}, // 在这里设置全局默认配置
// 	name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll
// });





// aos
import AOS from 'aos'
import 'aos/dist/aos.css'
//地图
import YmapPlugin from 'vue-yandex-maps'
import axios from 'axios'

//视频播放
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
window.videojs = VueVideoPlayer.videojs

axios.defaults.baseURL = 'https://www.margingroup.cn'
// axios.defaults.baseURL = 'http://192.168.0.67'
Vue.prototype.$axios = axios

import less from 'less'
Vue.use(less)
AOS.init()
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueVideoPlayer)
Vue.use(YmapPlugin, {
	apiKey: '6ad9319c-1644-4f8e-9d7b-bc82384e1370',
	lang: 'ru_RU',
	coordorder: 'latlong',
	enterprise: false,
	version: '2.1'
})
// router跳转之后执行的内容  to到哪里去 from从哪来
router.afterEach((to, from) => {
	// console.log('33333333333333333333333333333333333333')
	//   document.documentElement.scrollTop = 0

	setTimeout(() => {
		document.documentElement.scrollTop = 0
	}, 50)
})

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
}).$mount('#app')
